import * as React from 'react'

import { NextPage } from '@grandvisionhq/next'
import {
  ErrorCase,
  InitialProps,
  Page,
  Props,
} from '@grandvisionhq/www-next/pages/product-detail/sunglasses'
import { PromoteInstallmentsGraphContainer } from '@grandvisionhq/www-next/slot-components/PromoteInstallmentsGraphContainer'
import { RxGlassesConfiguratorGraphContainer } from '@grandvisionhq/www-next/slot-components/RxGlassesConfiguratorGraphContainer'

import OpticianForm from '../../../components/forms/Optician'
import { composePDP } from '../../../components/hocs/compose-pdp'
import {
  getDeliveryIndicatorConfig,
  graphPromoteInstallmentsConfiguration,
  sunglassesSpecifications,
} from '../../../configuration'

const slots: Props['slots'] = {
  AfterPrice: () => (
    <PromoteInstallmentsGraphContainer opcoConfiguration={graphPromoteInstallmentsConfiguration} />
  ),
  Configurator: (props) => (
    <RxGlassesConfiguratorGraphContainer {...props} opticianForm={OpticianForm} />
  ),
}

const ProductDetailPage: NextPage<Props, InitialProps | ErrorCase> = (props) => {
  const deliveryIndicatorConfig = getDeliveryIndicatorConfig()

  return (
    <Page
      {...props}
      slots={slots}
      deliveryIndicatorConfig={deliveryIndicatorConfig}
      specificationConfiguration={sunglassesSpecifications}
    />
  )
}

ProductDetailPage.getInitialProps = Page.getInitialProps

export default composePDP<Props>(ProductDetailPage)
